<template>
  <!-- Rendered into body, see OrderProductFileModal -->
  <Teleport to="body">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="inmodal">
          <div class="modal-header">
            <h4 class="modal-title">
              Prześlij plik źródłowy do pozycji zamówienia
              {{ orderProduct?.pk }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="form-horizontal">
              <div class="ibox-content">
                <div class="form-group">
                  <label class="control-label col-sm-2">Wybierz plik</label>
                  <div class="col-sm-10">
                    <div class="fileinput fileinput-new input-group">
                      <div class="form-control">
                        <input
                          ref="fileInput"
                          type="file"
                          name="file"
                          @change="onFileChange"
                        />
                      </div>
                    </div>
                    <div v-show="fileError" class="has-error">
                      <span class="help-block">{{ fileError }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button @click="$emit('close')" class="btn btn-white">
              Zamknij
            </button>
            <button
              v-if="canAddSourceFile"
              :disabled="isUploading"
              @click="submitForm"
              class="btn btn-primary"
            >
              {{ isUploading ? "Przesyłanie..." : "Prześlij" }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div @click="$emit('close')" class="modal-backdrop"></div>
  </Teleport>
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { hasPermission } from "../../permissions";
import { sourceFilePermissionsConst } from "../../constants/orderConstants";

// Mirrors OrderProductSourceFileModalController from the old admin panel.
export default {
  name: "OrderProductSourceFileModal",
  props: {
    orderProduct: { type: Object, required: true },
  },
  emits: ["close", "uploaded"],

  setup(props, { emit }) {
    const store = useStore();
    const canAddSourceFile = computed(() =>
      hasPermission(sourceFilePermissionsConst.add)
    );
    const fileInput = ref(null);
    const selectedFile = ref(null);
    const fileError = ref(null);
    const isUploading = ref(false);

    const onFileChange = (event) => {
      const files = event.target.files || event.dataTransfer.files;
      fileError.value = null;
      selectedFile.value = files.length ? files[0] : null;
    };

    const getResponseErrorMessage = (error, fallback) => {
      const data = error?.response?.data;
      if (!data) {
        return fallback;
      }
      if (typeof data === "string") {
        return data;
      }
      const entries = Object.entries(data);
      if (!entries.length) {
        return fallback;
      }
      const [key, value] = entries[0];
      return `${key}: ${Array.isArray(value) ? value[0] : value}`;
    };

    const submitForm = () => {
      if (!canAddSourceFile.value) {
        return;
      }

      if (!selectedFile.value) {
        fileError.value = "Wybierz plik.";
        return;
      }

      const orderProductPk = props.orderProduct.pk;
      fileError.value = null;
      isUploading.value = true;

      store
        .dispatch("createSourceFile", {
          orderProductPk: orderProductPk,
          file: selectedFile.value,
        })
        .then(() => {
          store.dispatch("showToaster", {
            type: "success",
            content: `Dodano plik źródłowy do pozycji zamówienia ${orderProductPk}`,
          });
          emit("uploaded");
          emit("close");
        })
        .catch((error) => {
          fileError.value = getResponseErrorMessage(
            error,
            "Nie udało się dodać pliku źródłowego."
          );
          store.dispatch("showToaster", {
            type: "error",
            content: fileError.value,
          });
        })
        .finally(() => {
          isUploading.value = false;
        });
    };

    return {
      fileInput,
      fileError,
      isUploading,
      onFileChange,
      submitForm,
      canAddSourceFile,
    };
  },
};
</script>
